export const color = {
  primaryBlue: "#202e50",
  markedDefault: "#ff9636",
  markedSecondary: "#3cb2c7",
  default: "#777180",
  secondary: "#f8f9f0",
  link: "#1890ff",
  warnning: "#fd0031",
  borderGray: "hsla(222.5, 42%, 21%, 0.1)",
};
